import classNames from 'classnames';

import styles from './ADengiDisclaimer.module.scss';

export function ADengiDisclaimer({
  heading,
  subheading,
  className,
}: {
  heading?: string;
  subheading?: string;
  className?: string;
}) {
  if (!heading && !subheading) {
    return null;
  }
  return (
    <div className={classNames(styles.content, className)}>
      {heading && <span className={styles.heading}>{heading}</span>}
      {subheading && <span className={styles.heading}>{subheading}</span>}
    </div>
  );
}
